<template>
    <div class="uw-conditions-box">
        <div class="uw-conditions-header">
            <div class="d-flex align-items-center gap-2">
                <span class="meta-header-icon meta-header-icon--blue">
                    <i class="bi bi-file-earmark-ruled-fill"></i>
                </span>
                <div>
                    <h6 class="mb-0 fw-bold meta-header-title">Xüsusi şərtlər</h6>
                    <small class="text-muted" style="font-size: 0.76rem;">Müqavilənin xüsusi bəndləri və hüquqi şərtləri</small>
                </div>
            </div>
            <span class="meta-chip meta-chip--blue">{{ data ? data.length : 0 }} şərt</span>
        </div>

        <div class="uw-conditions-body">
            <div class="table-responsive">
                <el-table border :data="data" class="el-table-css" style="width: 100%">
                    <el-table-column type="index" label="№" width="55" align="center" />
                    <el-table-column prop="descr" label="Şərtin mətni" min-width="400">
                        <template #default="scope">
                            <div class="condition-text py-1">{{ scope.row.descr }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="60" align="center">
                        <template #default="scope">
                            <el-popover
                                placement="left"
                                title="Tarixçə"
                                :width="240"
                                trigger="hover"
                            >
                                <template #reference>
                                    <button class="btn btn-sm btn-link p-0 text-muted" type="button">
                                        <i class="bi bi-info-circle fs-6"></i>
                                    </button>
                                </template>
                                <div class="popover-meta-content" style="font-size: 0.78rem;">
                                    <div class="d-flex justify-content-between py-1 border-bottom">
                                        <span class="text-muted">Daxil edilib:</span>
                                        <span class="font-monospace fw-bold">{{ scope.row.created }}</span>
                                    </div>
                                    <div class="d-flex justify-content-between py-1">
                                        <span class="text-muted">Düzəliş:</span>
                                        <span class="font-monospace fw-bold">{{ scope.row.updated }}</span>
                                    </div>
                                </div>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UnderwritingConditionsTable",
    props: {
        data: Array,
        refindex: Number,
        constindex: Number
    },
    data() {
        return {
            type: null,
            dialogVis: false,
            page: 1,
            object: null,
            editing: false,
            alert: false,
            sub: {
                constindex: null,
                refindex: 0
            }
        }
    }
}
</script>

<style scoped lang="scss">
.uw-conditions-box {
    background: var(--app-surface, #ffffff);
    border: 1px solid var(--app-border, #e2e8f0);
    border-radius: var(--app-radius, 8px);
    overflow: hidden;
}

.uw-conditions-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 12px 16px;
    background: var(--app-surface-soft, #f8fafc);
    border-bottom: 1px solid var(--app-border, #e2e8f0);
}

.meta-header-icon {
    width: 28px;
    height: 28px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.88rem;
    flex-shrink: 0;

    &--blue { background: rgba(11, 79, 156, 0.12); color: var(--bs-info, #0b4f9c); }
}

.meta-header-title {
    font-size: 0.88rem;
    color: var(--app-heading, #1e293b);
}

.meta-chip {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 9999px;
    font-size: 0.74rem;
    font-weight: 700;

    &--blue { background: rgba(11, 79, 156, 0.1); color: var(--bs-info, #0b4f9c); }
}

.uw-conditions-body {
    padding: 12px 16px;
}

.condition-text {
    font-size: 0.83rem;
    line-height: 1.5;
    color: var(--app-heading, #1e293b);
}

[data-theme="dark"] {
    .uw-conditions-box { background: #182029; border-color: #283544; }
    .uw-conditions-header { background: #141b22; border-color: #283544; }
    .meta-header-title { color: #f1f5f9; }
    .condition-text { color: #cbd5e1; }
}
</style>